import styled from 'styled-components';
import { InfoModal, Text } from 'ui-components';

export const StyledModal = styled(InfoModal)`
  .modal-body {
    padding: 0;
  }
`;

export const CardBlock = styled.div`
  max-width: 90vw;
  width: 1520px;
  min-height: 600px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  overflow-x: auto;
`;

export const SearchResultHeader = styled(Text).attrs({ type: 'h2' })`
  color: ${({ theme }) => theme.palette.gray.dark};
  margin: 35px 0 30px;
  padding: 0 30px;
`;

export const SpinnerBlock = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
